import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { CampaignBenchmarksPage } from './components/CampaignBenchmarksPage';

/**
 * Top-level router combining module-level routers
 */
const Router = () => {
  return (
    <Suspense>
      <Routes>
        <Route path="*" element={<CampaignBenchmarksPage />} />
      </Routes>
    </Suspense>
  );
};

Router.displayName = 'CampaignPlannerRouter';

export { Router };
